// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","scrolled":"Header_scrolled__jPUSR","nav":"Header_nav__ZwnMZ"};